import React from 'react'
import './WhatsappButton.css'

export default props =>
    <a href="https://api.whatsapp.com/send?phone=5511995507516&text=Ol%C3%A1%2C%20tudo%20bem%3F" target="_blank" rel="noopener noreferrer">
        <div className="whatsapp-icon">
            <i className="fab fa-whatsapp"></i>
        </div>
    </a>
